(function () {

    angular
        .module('app')
        .controller('QitanWorkspaceController', QitanWorkspaceController);

    QitanWorkspaceController.$inject = [
        'qitanAiContractService', 'loggerService', '$state', 'authService', '$window'
    ];

    function QitanWorkspaceController(qitanAiContractService, loggerService, $state, authService, $window) {
        var vm = this;
        var workspace = ($state.current.data && $state.current.data.workspace) || 'coding';

        var workspaceConfig = workspace === 'agent' ? {
            eyebrow : '智能体搭建 / 工作台',
            title : '正在进入智能体工作台',
            description : '正在通过启探平台完成免登录和课堂身份接入，并跳转到同源智能体工作台。',
            backRoute : 'qitanAi',
            backLabel : '返回智能体搭建',
            getEntryUrl : function () {
                return qitanAiContractService.getStudioEntryUrl('/space');
            },
            getLaunch : function () {
                return qitanAiContractService.getStudioLaunch('/space');
            },
            allowedPathPrefix : '/qitan-workbench/agent',
            emptyError : '智能体工作台入口没有返回可用地址',
            unsafeError : '智能体工作台返回了不受信任的地址',
            fallbackError : '智能体工作台暂时无法进入'
        } : {
            eyebrow : 'AI 编程 / 工作台',
            title : '正在进入 AI 编程工作台',
            description : '正在通过启探平台带入账号、班级和角色信息，并跳转到同源 AI 编程工作台。',
            backRoute : 'codingLab',
            backLabel : '返回 AI 编程',
            getEntryUrl : function () {
                return qitanAiContractService.getCodingWorkbenchEntryUrl();
            },
            getLaunch : function () {
                return qitanAiContractService.getCodingWorkbenchLaunch();
            },
            allowedPathPrefix : '/qitan-workbench/coding',
            emptyError : 'AI 编程工作台入口没有返回可用地址',
            unsafeError : 'AI 编程工作台返回了不受信任的地址',
            fallbackError : 'AI 编程工作台暂时无法进入'
        };

        vm.workspace = workspace;
        vm.eyebrow = workspaceConfig.eyebrow;
        vm.title = workspaceConfig.title;
        vm.description = workspaceConfig.description;
        vm.backHref = qitanAiContractService.routes[workspaceConfig.backRoute];
        vm.backLabel = workspaceConfig.backLabel;
        vm.loading = true;
        vm.error = '';
        vm.launchUrl = workspaceConfig.getEntryUrl();
        vm.reload = launchWorkspace;

        launchWorkspace();

        function launchWorkspace() {
            vm.loading = true;
            vm.error = '';
            vm.launchUrl = workspaceConfig.getEntryUrl();

            authService.requirePlatformSessionCookie()
                .then(function () {
                    return workspaceConfig.getLaunch();
                })
                .then(function (launch) {
                    var parsedUrl;
                    if (!launch || !launch.url) {
                        throw new Error(workspaceConfig.emptyError);
                    }
                    try {
                        parsedUrl = new $window.URL(launch.url, $window.location.origin);
                    }
                    catch (err) {
                        throw new Error(workspaceConfig.unsafeError);
                    }
                    if (parsedUrl.origin !== $window.location.origin ||
                        !isAllowedLaunchPath(parsedUrl.pathname, workspaceConfig.allowedPathPrefix)) {
                        throw new Error(workspaceConfig.unsafeError);
                    }
                    vm.launchUrl = parsedUrl.href;
                    $window.location.href = vm.launchUrl;
                })
                .catch(function (err) {
                    loggerService.error(err);
                    if (err && err.requiresLogin) {
                        return authService.login($state.current.name, $state.params || {})
                            .catch(function (loginErr) {
                                loggerService.error(loginErr);
                                showLaunchError(loginErr);
                            });
                    }
                    showLaunchError(err);
                });
        }

        function showLaunchError(err) {
            vm.loading = false;
            vm.error = (err && err.data && (err.data.error || err.data.next)) ||
                (err && err.message) ||
                workspaceConfig.fallbackError;
        }

        function isAllowedLaunchPath(pathname, allowedPathPrefix) {
            return pathname === allowedPathPrefix ||
                pathname.indexOf(allowedPathPrefix + '/') === 0;
        }
    }
}());
